/*
스크립트 에러 케이스
1. 렌더링시 발생하는 에러
- 특정 화면에 접근
- 특정 화면 컴포넌트 렌더링
- 특정 화면 컴포넌트 렌더링 시 에러 발생
- 해당 에러가 발생하면 ErrorBoundary에서 에러 캐치
- onError 콜백 함수 실행
>>> 이후 이슈 상황 <<<
- fallbackRender가 children을 다시 렌더링
- 에러 무한 발생

2. 클릭이벤트에서 발생하는 에러
- 클릭 이벤트 발생
- 최초 클릭 이벤트에 발생한 에러는 ErrorBoundary에서 catch
- 두번째 발생하는 클릭이벤트는 ErrorBoundary에서 catch 되지 않고, ErrorBoundaryProvider의 showBoundary에서 catch
>>> 이슈 없음 <<<
*/

import { ErrorBoundary } from 'react-error-boundary';

import { handleError } from './handle-error';
import { ErrorBoundaryProvider } from './error-provider';

const ErrorBoundaryWrapper = ({ children }: { children: any }) => (
  <ErrorBoundary fallbackRender={() => children} onError={handleError}>
    <ErrorBoundaryProvider>{children}</ErrorBoundaryProvider>
  </ErrorBoundary>
);

export default ErrorBoundaryWrapper;
